(function($) {
    $(() => {

        $('.slider-container .slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: '.slider-container .arrow--right',
            prevArrow: '.slider-container .arrow--left'
        });

        $('.partner-slider-container .slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: '.partner-slider-container .arrow--right',
            prevArrow: '.partner-slider-container .arrow--left'
        });

        $('.cover__slider-container').slick({
            infinite: true,
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1
        });

    });
})(jQuery);
